export const maxCategoryResourceBatchCount = 20000
export const serviceSiteName = "main"